import { twMerge } from 'tailwind-merge';
import MuiDivider, {
  type DividerProps as MuiDividerProps,
} from '@mui/material/Divider';
import { classes } from './utils';

export type DividerProps = MuiDividerProps;

export default function Divider({ className, ...props }: DividerProps) {
  return (
    <MuiDivider className={twMerge(classes.divider, className)} {...props} />
  );
}
